<script setup lang="ts">
import { Heading } from '~/components/ui/heading'
import { SidebarBlock } from '~/components/ui/sidebar-block'
import type { IRequestFormLink } from './types'

const props = defineProps<IRequestFormLink>()
</script>

<template>
  <SidebarBlock variant="white">
    <div class="flex flex-col gap-2">
      <Heading tag="h2" class="h4">
        {{ props.title }}
      </Heading>
      <p>
        {{ props.description }}
      </p>
    </div>

    <div class="flex flex-col gap-3">
      <Button class="w-full" as-child>
        <NuxtLink :to="props.button.link">
          {{ props.button.label }}
        </NuxtLink>
      </Button>

      <div class="flex items-center gap-2">
        <div v-if="props.message.icon" class="flex-shrink-0 [&>svg]:size-5">
          <UiIcon :name="props.message.icon" />
        </div>
        <span class="text-sm font-semibold text-gray-900">{{ props.message.text }}</span>
      </div>
    </div>
  </SidebarBlock>
</template>
